import { connect } from "react-redux";

import { getGanSuppliersList, clearGanSuppliersList } from "actions/gan_suppliers";
import GanSuppliers from "./GanSuppliers";


const mapStateToProps = ({ gan_suppliers }) => ({
    data: gan_suppliers.list,
    loading: gan_suppliers.loading,
});

export default connect(mapStateToProps, {
    getGanSuppliersList,
    clearGanSuppliersList
})(GanSuppliers);